<template>
    <div class="left_panel">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading">
                <h2>My Designs</h2>
                <div class="subhead">Manage your saved designs</div>
            </div>
        </div>

        <div class="my-designs-wrap">
            <!-- Search and Filter Section -->
            <div class="top-search_items mb-3 d-flex justify-content-end">
                <div class="col-md-2 px-0">
                    <div class="search_field position-relative mg-b-12">
                        <img
                            src="/maincss/images/search-grey.svg"
                            class="search_icon"
                            alt=""
                        />
                        <input
                            type="text"
                            placeholder="Search Design"
                            v-model="design_search_query"
                            class="form-control"
                        />
                    </div>
                </div>
                <div class="filter_field ml-2">
                    <button
                        type="button"
                        class="filter-btn"
                        @click="toggleFilterPopup"
                    >
                        <img src="/maincss/images/filter.svg" alt="" />
                        Filter
                        <span
                            v-if="activeFilterCount > 0"
                            class="filter-badge"
                            >{{ activeFilterCount }}</span
                        >
                    </button>

                    <!-- Filter Popup -->
                    <div v-if="showFilterPopup" class="filter-popup">
                        <div class="filter-popup-header">
                            <h3 class="filter-popup-title">Filter</h3>
                            <button
                                type="button"
                                class="filter-clear-btn"
                                @click="clearFilters"
                            >
                                Clear
                            </button>
                        </div>

                        <div class="filter-popup-content">
                            <div class="filter-section">
                                <h4 class="filter-section-title">Categories</h4>
                                <div class="filter-options">
                                    <label
                                        v-for="category in all_category_list"
                                        :key="category.id"
                                        class="filter-option-label"
                                    >
                                        <input
                                            type="radio"
                                            name="category_filter"
                                            :value="category.id"
                                            v-model="selectedCategoryFilter"
                                            @change="onCategoryFilterChange"
                                        />
                                        <span class="filter-option-text">{{
                                            category.title
                                        }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="filter-popup-footer">
                            <button
                                type="button"
                                class="filter-apply-btn"
                                @click="applyFilters"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!filteredDesigns || filteredDesigns.length == 0"
                class="no-results"
            >
                <span>No designs found.</span>
            </div>
            <div
                v-else
                class="designs-grid"
            >
                <DesignCard
                    v-for="(design, index) in paginatedDesigns"
                    :key="design.id || index"
                    :design="design"
                    @delete="handleDeleteDesign"
                />
            </div>
            <b-pagination
                v-show="filteredDesigns.length > 0 && filteredDesigns.length > itemsPerPage"
                v-model="currentPage"
                :total-rows="filteredDesigns.length"
                :per-page="itemsPerPage"
                class="imprint_pagination"
                @input="handlePageChange"
            ></b-pagination>
        </div>
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import DesignCard from "@/components/frontend/account/DesignCard.vue";

export default {
    name: "MyDesign",
    components: {
        DesignCard
    },
    data() {
        return {
            savedDesigns: [],
            isLoader: false,
            listConfig: {
                category_id: null,
                attribute_set_id: null
            },
            item_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            total_designs: 0,
            design_search_query: null,
            all_category_list: [],
            showFilterPopup: false,
            selectedCategoryFilter: "All"
        };
    },
    computed: {
        pages() {
            if (this.item_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.item_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        },
        filteredDesigns() {
            if (this.design_search_query) {
                return this.savedDesigns.filter((item) => {
                    return item.name
                        .toLowerCase()
                        .includes(this.design_search_query.toLowerCase());
                });
            } else {
                return this.savedDesigns || [];
            }
        },
        paginatedDesigns() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredDesigns.slice(start, end);
        },
        activeFilterCount() {
            let count = 0;
            if (
                this.selectedCategoryFilter &&
                this.selectedCategoryFilter !== "All"
            ) {
                count++;
            }
            return count;
        }
    },
    watch: {
        currentPage() {
            // Scroll to top when page changes
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        design_search_query() {
            // Reset to first page when search query changes
            this.currentPage = 1;
        }
    },
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        var _this = this;
        _this.listConfig = {
            category_id: null,
            attribute_set_id: null
        };
        _this.getAllCategories().then(() => {
            _this.getSavedDesigns();
        });
    },
    methods: {
        getSavedDesigns(pagereset = false) {
            var _this = this;
            if (pagereset) {
                _this.currentPage = 1;
            }
            _this.isLoader = true;
            ApiService.setHeader();
            ApiService.query("/get-design-image-v2", {
                params: _this.listConfig
            })
                .then(({ data }) => {
                    _this.savedDesigns = data.design || [];
                    _this.total_designs = data.count || _this.savedDesigns.length || 0;
                    _this.item_length = data.count || _this.savedDesigns.length || 0;
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                    if (response && response.status == 401) {
                        _this.$router.push({ name: "/client/login" });
                    } else {
                        this.$toast.error("Failed to load designs", {
                            position: "top-right"
                        });
                    }
                });
        },
        handlePageChange(page) {
            this.currentPage = page;
        },
        handleDeleteDesign(designId) {
            if (confirm("Do you really want to delete this design?")) {
                this.isLoader = true;
                ApiService.post("/delete_canvasimages", {
                    ids: [designId.toString()]
                })
                    .then(() => {
                        this.$toast.success("Design deleted successfully", {
                            position: "top-right"
                        });
                        this.getSavedDesigns();
                    })
                    .catch(({ response }) => {
                        this.isLoader = false;
                        if (response && response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        } else {
                            this.$toast.error("Failed to delete design", {
                                position: "top-right"
                            });
                        }
                    });
            }
        },
        isValidHttpUrl(string) {
            if (!string) return false;
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },
        toggleFilterPopup() {
            this.showFilterPopup = !this.showFilterPopup;
        },
        closeFilterPopup() {
            this.showFilterPopup = false;
        },
        clearFilters() {
            this.selectedCategoryFilter = "All";
            this.listConfig.category_id = null;
            this.getSavedDesigns(true);
            this.closeFilterPopup();
        },
        onCategoryFilterChange() {
            // Update when radio changes
        },
        applyFilters() {
            if (
                this.selectedCategoryFilter &&
                this.selectedCategoryFilter !== "All"
            ) {
                this.listConfig.category_id = this.selectedCategoryFilter;
            } else {
                this.listConfig.category_id = null;
            }
            this.getSavedDesigns(true);
            this.closeFilterPopup();
        },
        getAllCategories() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-all-categories-list")
                    .then(({ data }) => {
                        this.all_category_list = data.categories;
                        this.all_category_list.unshift({
                            id: "All",
                            title: "All"
                        });
                        // Initialize selected category filter
                        if (this.listConfig.category_id) {
                            this.selectedCategoryFilter =
                                this.listConfig.category_id;
                        } else {
                            this.selectedCategoryFilter = "All";
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>

<style scoped>
.my-designs-wrap {
    margin-top: 24px;
}

.no-results {
    text-align: center;
    padding: 40px;
    color: #888888;
    font-size: 16px;
}

.designs-grid {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}
.designs-grid .design-card {
           flex: 0 0 49%;
        max-width: 49%;
}

/* Search and Filter Styles */
.top-search_items {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
}

.search_field {
    position: relative;
    width: 100%;
}

.search_icon {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
}

.search_field .form-control {
    padding-left: 30px !important;
}

.filter_field {
    position: relative;
}

.filter-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

.filter-badge {
    background: #ff6b6b;
    color: #fff;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: 600;
    margin-left: 4px;
}

.filter-popup {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    width: 263px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9;
    display: flex;
    flex-direction: column;
    max-height: 330px;
}

.filter-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;
}

.filter-popup-title {
    font-size: 18px;
    font-weight: 700;
    color: #121212;
    margin: 0;
}

.filter-clear-btn {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
}

.filter-clear-btn:hover {
    color: #333;
}

.filter-popup-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
}

.filter-section {
    margin-bottom: 16px;
}

.filter-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #121212;
    margin-bottom: 12px;
}

.filter-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.filter-option-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0px;
    transition: background-color 0.2s;
    margin-bottom: 0px;
}

.filter-option-label:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
}

.filter-option-label input[type="radio"] {
    width: 18px;
    height: 18px;
    margin: 0;
    margin-right: 12px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 2px solid #ccc;
    border-radius: 50%;
    outline: none;
    position: relative;
    flex-shrink: 0;
    left: 0px;
}

.filter-option-label input[type="radio"]:checked {
    border-color: #0079c1;
    background-color: #fff;
}

.filter-option-label input[type="radio"]:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #0079c1;
}

.filter-option-text {
    font-size: 14px;
    color: #121212;
    line-height: 1.5;
}

.filter-popup-footer {
    padding: 16px 20px;
    border-top: 1px solid #e0e0e0;
}

.filter-apply-btn {
    width: 100%;
    padding: 10px;
    background: #f2790c;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.filter-apply-btn:hover {
    background: #0056b3;
}

@media (max-width: 1200px) {
    .designs-grid .design-card {
           flex: 0 0 48%;
        max-width: 48%;
    }
}
@media (max-width: 768px) {
    .designs-grid .design-card {
           flex: 0 0 100%;
        max-width: 100%;
    }
    
    .top-search_items {
        flex-direction: column;
    }
    
    .filter-popup {
        width: 100%;
        right: auto;
        left: 0;
    }
}
</style>